<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="12" class="text-center text-sm-left flex-header">
                <h3 class="page-title">Nowy klient</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'clients-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button theme="success" @click.prevent="submitForm"><i class="material-icons">add</i> Dodaj klienta</d-button>
            </d-col>
        </d-row>
        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">

                <d-list-group flush @keyup.enter="submitForm">
                    <d-form>
                        <div class="ss-tabs-wrapper">
                            <ul class="ss-tabs-nav">
                                <li :class="{ active: activeTab === 0, 'has-error': hasErrorsTabPersonal}"
                                    @click="activeTab = 0"><span>Dane podstawowe</span></li>
                                <li :class="{ active: activeTab === 1, 'has-error': hasErrorsTabAddress}"
                                    @click="activeTab = 1"><span>Dane korespondencyjne</span></li>
                                <li  class="disabled">
                                    <ss-popover>
                                        <span>Poręczyciele</span>
                                        <template slot="tooltip">
                                            Zakładka będzie dostępna zaraz po dodaniu klienta.
                                        </template>
                                    </ss-popover>
                                </li>
                                <li class="disabled">
                                    <ss-popover>
                                        <span>Zabezpieczenia</span>
                                        <template slot="tooltip">
                                            Zakładka będzie dostępna zaraz po dodaniu klienta.
                                        </template>
                                    </ss-popover>
                                </li>
                                <li class="disabled">
                                    <ss-popover>
                                        <span>Dokumenty</span>
                                        <template slot="tooltip">
                                            Zakładka będzie dostępna zaraz po dodaniu klienta.
                                        </template>
                                    </ss-popover>
                                </li>
                                <li class="disabled">
                                    <ss-popover>
                                        <span>Umowy</span>
                                        <template slot="tooltip">
                                            Zakładka będzie dostępna zaraz po dodaniu klienta.
                                        </template>
                                    </ss-popover>
                                </li>
                                <li class="disabled">
                                    <ss-popover>
                                        <span>Historia kontaktu</span>
                                        <template slot="tooltip">
                                            Zakładka będzie dostępna zaraz po dodaniu klienta.
                                        </template>
                                    </ss-popover>
                                </li>
                            </ul>
                            <ul class="ss-tabs">
                                <li :class="{ active: activeTab === 0}">
                                    <d-card-header class="border-bottom">
                                        <h6 class="m-0">Podstawowe dane klienta</h6>
                                    </d-card-header>
                                    <personal-data
                                        ref="personalData"
                                        :props="client" />
                                </li>
                                <li :class="{ active: activeTab === 1}">
                                    <d-row>
                                        <d-col>
                                            <d-card-header class="border-bottom flex-header">
                                                <h6 class="m-0">Dane siedziby</h6>
                                                <d-button @click.prevent="copyBusinessData"><i class="material-icons">filter_none</i> Kopiuj dane adresowe</d-button>
                                            </d-card-header>
                                            <address-business :props="client" />
                                            <d-card-header class="border-bottom flex-header">
                                                <h6 class="m-0">Dane korespondencyjne</h6>
                                                <d-button @click.prevent="copyInvoiceData"><i class="material-icons">filter_none</i> Kopiuj dane do faktury</d-button>
                                            </d-card-header>
                                            <address-data :props="client" />
                                        </d-col>
                                        <d-col>
                                            <d-card-header class="border-top">
                                                <h6 class="m-0">Dane do faktury</h6>
                                            </d-card-header>
                                            <invoice-data :props="client" />
                                        </d-col>
                                    </d-row>
                                </li>
                                <li :class="{ active: activeTab === 2}">
                                    <d-card-header class="border-bottom">
                                        <h6 class="m-0">Poręczyciele</h6>
                                    </d-card-header>
                                    <guarantors-list />
                                </li>
                            </ul>
                        </div>
                    </d-form>
                </d-list-group>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import SsPopover from '../components/common/SsPopover';
    import LarErrors from '../helpers/Errors';
    import AddressData from '../components/client/AddressData';
    import AddressBusiness from '../components/client/AddressBusiness';
    import AddressResidence from '../components/client/AddressResidence';
    import InvoiceData from '../components/client/InvoiceData';
    import PersonalData from '../components/client/PersonalData';
    import GuarantorsList from '../components/client/GuarantorsList';

    export default {
        name: "ClientNew",
        components: {
            LarErrors,
            AddressData,
            AddressBusiness,
            AddressResidence,
            InvoiceData,
            PersonalData,
            GuarantorsList,
            SsPopover
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                activeTab: 0,
                client: {
                    name:       '',
                    surname:    '',
                    company_nem: '',
                    email:      '',
                    phone:      '',
                    status:     null,
                    type:       null,
                    id_card:    '',
                    id_card_type:       'id',
                    pesel:      '',
                    nip:        '',
                    regon:              '',
                    resolution_date:    '',
                    krs:                '',
                    company_id: null,
                    invoice_name:       '',
                    invoice_address:    '',
                    invoice_city:       '',
                    invoice_postcode:   '',
                    invoice_tax_number: '',
                    invoice_street:     '',
                    invoice_house_number:  '',
                    invoice_flat_number:  '',
                    correspondence_street:          '',
                    correspondence_house_number:    '',
                    correspondence_postcode:        '',
                    correspondence_city:            '',
                    residence_street:               '',
                    residence_house_number:         '',
                    residence_flat_number:         '',
                    residence_postcode:             '',
                    residence_city:                 '',
                    business_street:                '',
                    business_house_number:          '',
                    business_flat_number:          '',
                    business_postcode:              '',
                    business_city:                  '',
                    is_second_person:   '0',
                    second_name:        '',
                    second_surname:     '',
                    second_email:       '',
                    second_phone:       '',
                    second_pesel:       '',
                    second_id_card:     '',
                    second_id_card_type:'id',
                    second_type:        '',
                    second_residence_street:        '',
                    second_residence_house_number:  '',
                    second_residence_flat_number:  '',
                    second_residence_postcode:      '',
                    second_residence_city:          '',
                    second_person_marital_status:          null,
                    second_person_marital_status_other:    '',
                    second_person_property_separation:     null,
                    client_internal:               '0',
                    marital_status:                null,
                    marital_status_other:          ''
                },
            }
        },
        computed:{
          ...mapGetters([
              'allCompanies'
            ]),
            hasErrorsTabPersonal() {
                return this.lar_errors.errors.name ||
                    this.lar_errors.errors.surname ||
                    this.lar_errors.errors.email ||
                    this.lar_errors.errors.phone ||
                    this.lar_errors.errors.company_id
            },
            hasErrorsTabAddress() {
                return this.lar_errors.errors.correspondence_street ||
                    this.lar_errors.errors.correspondence_house_number ||
                    this.lar_errors.errors.correspondence_postcode ||
                    this.lar_errors.errors.correspondence_city ||
                    this.lar_errors.errors.invoice_name ||
                    this.lar_errors.errors.invoice_address ||
                    this.lar_errors.errors.invoice_city ||
                    this.lar_errors.errors.invoice_postcode
            }
        },
        methods: {
            ...mapActions([
                'getAllCompanies'
            ]),
            copyInvoiceData(){
                this.client.correspondence_city = this.client.invoice_city;
                this.client.correspondence_street = this.client.invoice_street;
                this.client.correspondence_house_number = this.client.invoice_house_number;
                this.client.correspondence_flat_number = this.client.invoice_flat_number;
                this.client.correspondence_postcode = this.client.invoice_postcode;
                this.$forceUpdate();
            },
            copyResidenceData(){
                this.client.residence_city = this.client.correspondence_city;
                this.client.residence_street = this.client.correspondence_street;
                this.client.residence_house_number = this.client.correspondence_house_number;
                this.client.residence_flat_number = this.client.correspondence_flat_number;
                this.client.residence_postcode = this.client.correspondence_postcode;
                this.$forceUpdate();
            },
            copyBusinessData(){
                this.client.business_city = this.client.correspondence_city;
                this.client.business_street = this.client.correspondence_street;
                this.client.business_house_number = this.client.correspondence_house_number;
                this.client.business_flat_number = this.client.correspondence_flat_number;
                this.client.business_postcode = this.client.correspondence_postcode;
                this.$forceUpdate();
            },
            submitForm(){
                this.submitting = true;
                if (this.client.type === 'corporation') {
                    this.client.representatives = this.$refs.personalData.getRepresentatives();
                }

                axios.post('api/clients/save-client', this.client).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Klient został dodany.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.$router.push({name: 'client-edit', params: {id: response.data.id}});
                    });
                    this.submitting = false;
                }).catch((error) =>{
                    Vue.swal({
                        type: 'error',
                        title: error.response.data.message,
                        html: Vue.transformErrorsToHtml(error.response.data.errors),
                        showConfirmButton: true,
                    });
                    this.submitting = false;
                    LarErrors.record(error.response.data.errors)
                })
            }
        },
        mounted(){
            this.getAllCompanies();
            this.fetched = true;
        },
        watch: {
            'client.nip'(to, from){
                if(this.client.type === "corporation"){
                    this.client.invoice_tax_number = to;
                }
            },
            'client.company_name'(to, from){
                if(this.client.type === "corporation"){
                    this.client.invoice_name = to;
                }
            }
        }
    }
</script>
